import freeCodeCamp from './freeCodeCampCertification'
import photosNorway from './photosNorway'
import photosEngland from './photosEngland'
import photosBolivia from './photosBolivia'

export default [
  photosEngland,
  photosBolivia,
  photosNorway,
  freeCodeCamp,
]